const isSafeReturnPath = (value) => (
    typeof value === 'string'
    && value.startsWith('/')
    && !value.startsWith('//')
    && !value.includes('\\')
    && !value.includes('#')
    && value.length <= 512
    && value !== '/login'
);

export const getSafePostLoginPath = (search = '') => {
    const requestedPath = new URLSearchParams(search).get('return_to');
    return isSafeReturnPath(requestedPath) ? requestedPath : '/';
};

export const buildLoginRedirect = ({ pathname = '/', search = '' } = {}) => {
    const returnTo = `${pathname}${search}`;
    const safeReturnTo = isSafeReturnPath(returnTo) ? returnTo : '/';
    return `/login?${new URLSearchParams({ return_to: safeReturnTo }).toString()}`;
};
